var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _construct = require("/opt/build/repo/node_modules/@babel/runtime/helpers/construct.js");
var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var g = Object.defineProperty;
var j = Object.getOwnPropertyDescriptor;
var L = Object.getOwnPropertyNames;
var V = Object.prototype.hasOwnProperty;
var Y = function Y(e, r) {
    for (var t in r) g(e, t, {
      get: r[t],
      enumerable: !0
    });
  },
  K = function K(e, r, t, o) {
    if (r && typeof r == "object" || typeof r == "function") {
      var _iterator = _createForOfIteratorHelper(L(r)),
        _step;
      try {
        var _loop = function _loop() {
          var s = _step.value;
          !V.call(e, s) && s !== t && g(e, s, {
            get: function get() {
              return r[s];
            },
            enumerable: !(o = j(r, s)) || o.enumerable
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return e;
  };
var $ = function $(e) {
  return K(g({}, "__esModule", {
    value: !0
  }), e);
};
var h = function h(e, r, t) {
  return new Promise(function (o, s) {
    var i = function i(a) {
        try {
          l(t.next(a));
        } catch (m) {
          s(m);
        }
      },
      c = function c(a) {
        try {
          l(t.throw(a));
        } catch (m) {
          s(m);
        }
      },
      l = function l(a) {
        return a.done ? o(a.value) : Promise.resolve(a.value).then(i, c);
      };
    l((t = t.apply(e, r)).next());
  });
};
var W = {};
Y(W, {
  SubmissionError: function SubmissionError() {
    return p;
  },
  appendExtraData: function appendExtraData() {
    return E;
  },
  createClient: function createClient() {
    return F;
  },
  getDefaultClient: function getDefaultClient() {
    return U;
  },
  isSubmissionError: function isSubmissionError() {
    return A;
  }
});
module.exports = $(W);
var u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  J = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
function I(e) {
  e = String(e);
  for (var r, t, o, s, i = "", c = 0, l = e.length % 3; c < e.length;) {
    if ((t = e.charCodeAt(c++)) > 255 || (o = e.charCodeAt(c++)) > 255 || (s = e.charCodeAt(c++)) > 255) throw new TypeError("Failed to execute 'btoa' on 'Window': The string to be encoded contains characters outside of the Latin1 range.");
    r = t << 16 | o << 8 | s, i += u.charAt(r >> 18 & 63) + u.charAt(r >> 12 & 63) + u.charAt(r >> 6 & 63) + u.charAt(r & 63);
  }
  return l ? i.slice(0, l - 3) + "===".substring(l) : i;
}
function O(e) {
  if (e = String(e).replace(/[\t\n\f\r ]+/g, ""), !J.test(e)) throw new TypeError("Failed to execute 'atob' on 'Window': The string to be decoded is not correctly encoded.");
  e += "==".slice(2 - (e.length & 3));
  for (var r, t = "", o, s, i = 0; i < e.length;) r = u.indexOf(e.charAt(i++)) << 18 | u.indexOf(e.charAt(i++)) << 12 | (o = u.indexOf(e.charAt(i++))) << 6 | (s = u.indexOf(e.charAt(i++))), t += o === 64 ? String.fromCharCode(r >> 16 & 255) : s === 64 ? String.fromCharCode(r >> 16 & 255, r >> 8 & 255) : String.fromCharCode(r >> 16 & 255, r >> 8 & 255, r & 255);
  return t;
}
var G = function G() {
    return navigator.webdriver || !!document.documentElement.getAttribute(O("d2ViZHJpdmVy")) || !!window.callPhantom || !!window._phantom;
  },
  y = /*#__PURE__*/function () {
    "use strict";

    function y() {
      _classCallCheck(this, y);
      this.loadedAt = Date.now(), this.webdriver = G();
    }
    _createClass(y, [{
      key: "data",
      value: function data() {
        return {
          loadedAt: this.loadedAt,
          webdriver: this.webdriver
        };
      }
    }]);
    return y;
  }();
var S = /*#__PURE__*/_createClass(function S(r) {
  "use strict";

  _classCallCheck(this, S);
  this.kind = "success";
  this.next = r.next;
});
function w(e) {
  return "next" in e && typeof e.next == "string";
}
var b = /*#__PURE__*/_createClass(function b(r, t) {
  "use strict";

  _classCallCheck(this, b);
  this.paymentIntentClientSecret = r;
  this.resubmitKey = t;
  this.kind = "stripePluginPending";
});
function _(e) {
  if ("stripe" in e && "resubmitKey" in e && typeof e.resubmitKey == "string") {
    var r = e.stripe;
    return typeof r == "object" && r != null && "paymentIntentClientSecret" in r && typeof r.paymentIntentClientSecret == "string";
  }
  return !1;
}
function A(e) {
  return e.kind === "error";
}
var p = /*#__PURE__*/function () {
  "use strict";

  function p() {
    _classCallCheck(this, p);
    this.kind = "error";
    this.formErrors = [];
    this.fieldErrors = new Map();
    var t;
    for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
      r[_key] = arguments[_key];
    }
    for (var _i = 0, _r = r; _i < _r.length; _i++) {
      var o = _r[_i];
      if (!o.field) {
        this.formErrors.push({
          code: o.code && z(o.code) ? o.code : "UNSPECIFIED",
          message: o.message
        });
        continue;
      }
      var s = (t = this.fieldErrors.get(o.field)) != null ? t : [];
      s.push({
        code: o.code && Q(o.code) ? o.code : "UNSPECIFIED",
        message: o.message
      }), this.fieldErrors.set(o.field, s);
    }
  }
  _createClass(p, [{
    key: "getFormErrors",
    value: function getFormErrors() {
      return _toConsumableArray(this.formErrors);
    }
  }, {
    key: "getFieldErrors",
    value: function getFieldErrors(r) {
      var t;
      return (t = this.fieldErrors.get(r)) != null ? t : [];
    }
  }, {
    key: "getAllFieldErrors",
    value: function getAllFieldErrors() {
      return Array.from(this.fieldErrors);
    }
  }]);
  return p;
}();
function z(e) {
  return e in B;
}
var B = {
  BLOCKED: "BLOCKED",
  EMPTY: "EMPTY",
  FILES_TOO_BIG: "FILES_TOO_BIG",
  FORM_NOT_FOUND: "FORM_NOT_FOUND",
  INACTIVE: "INACTIVE",
  NO_FILE_UPLOADS: "NO_FILE_UPLOADS",
  PROJECT_NOT_FOUND: "PROJECT_NOT_FOUND",
  TOO_MANY_FILES: "TOO_MANY_FILES"
};
function Q(e) {
  return e in Z;
}
var Z = {
  REQUIRED_FIELD_EMPTY: "REQUIRED_FIELD_EMPTY",
  REQUIRED_FIELD_MISSING: "REQUIRED_FIELD_MISSING",
  STRIPE_CLIENT_ERROR: "STRIPE_CLIENT_ERROR",
  STRIPE_SCA_ERROR: "STRIPE_SCA_ERROR",
  TYPE_EMAIL: "TYPE_EMAIL",
  TYPE_NUMERIC: "TYPE_NUMERIC",
  TYPE_TEXT: "TYPE_TEXT"
};
function P(e) {
  return "errors" in e && Array.isArray(e.errors) && e.errors.every(function (r) {
    return typeof r.message == "string";
  }) || "error" in e && typeof e.error == "string";
}
var D = "3.0.4";
var v = function v(e) {
    return I(JSON.stringify(e));
  },
  N = function N(e) {
    var r = "@formspree/core@".concat(D);
    return e ? "".concat(e, " ").concat(r) : r;
  };
function E(e, r, t) {
  e instanceof FormData ? e.append(r, t) : e[r] = t;
}
function M(e) {
  return e !== null && typeof e == "object";
}
var R = /*#__PURE__*/function () {
  "use strict";

  function R() {
    var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, R);
    this.project = r.project, this.stripe = r.stripe, typeof window != "undefined" && (this.session = new y());
  }
  _createClass(R, [{
    key: "submitForm",
    value: function submitForm(s, i) {
      return h(this, arguments, function (r, t) {
        var _this = this;
        var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var c, l, a, m, f, d, n, x, T;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                m = function _m(f) {
                  return h(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var n, _n;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return fetch(l, {
                            method: "POST",
                            mode: "cors",
                            body: f instanceof FormData ? f : JSON.stringify(f),
                            headers: a
                          });
                        case 3:
                          _context.next = 5;
                          return _context.sent.json();
                        case 5:
                          n = _context.sent;
                          if (!M(n)) {
                            _context.next = 13;
                            break;
                          }
                          if (!P(n)) {
                            _context.next = 9;
                            break;
                          }
                          return _context.abrupt("return", Array.isArray(n.errors) ? _construct(p, _toConsumableArray(n.errors)) : new p({
                            message: n.error
                          }));
                        case 9:
                          if (!_(n)) {
                            _context.next = 11;
                            break;
                          }
                          return _context.abrupt("return", new b(n.stripe.paymentIntentClientSecret, n.resubmitKey));
                        case 11:
                          if (!w(n)) {
                            _context.next = 13;
                            break;
                          }
                          return _context.abrupt("return", new S({
                            next: n.next
                          }));
                        case 13:
                          return _context.abrupt("return", new p({
                            message: "Unexpected response format"
                          }));
                        case 16:
                          _context.prev = 16;
                          _context.t0 = _context["catch"](0);
                          _n = _context.t0 instanceof Error ? _context.t0.message : "Unknown error while posting to Formspree: ".concat(JSON.stringify(_context.t0));
                          return _context.abrupt("return", new p({
                            message: _n
                          }));
                        case 20:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee, null, [[0, 16]]);
                  }));
                };
                c = o.endpoint || "https://formspree.io", l = _this.project ? "".concat(c, "/p/").concat(_this.project, "/f/").concat(r) : "".concat(c, "/f/").concat(r), a = {
                  Accept: "application/json",
                  "Formspree-Client": N(o.clientName)
                };
                _this.session && (a["Formspree-Session-Data"] = v(_this.session.data())), t instanceof FormData || (a["Content-Type"] = "application/json");
                if (!(_this.stripe && o.createPaymentMethod)) {
                  _context2.next = 27;
                  break;
                }
                _context2.next = 6;
                return o.createPaymentMethod();
              case 6:
                f = _context2.sent;
                if (!f.error) {
                  _context2.next = 9;
                  break;
                }
                return _context2.abrupt("return", new p({
                  code: "STRIPE_CLIENT_ERROR",
                  field: "paymentMethod",
                  message: "Error creating payment method"
                }));
              case 9:
                E(t, "paymentMethod", f.paymentMethod.id);
                _context2.next = 12;
                return m(t);
              case 12:
                d = _context2.sent;
                if (!(d.kind === "error")) {
                  _context2.next = 15;
                  break;
                }
                return _context2.abrupt("return", d);
              case 15:
                if (!(d.kind === "stripePluginPending")) {
                  _context2.next = 26;
                  break;
                }
                _context2.next = 18;
                return _this.stripe.handleCardAction(d.paymentIntentClientSecret);
              case 18:
                n = _context2.sent;
                if (!n.error) {
                  _context2.next = 21;
                  break;
                }
                return _context2.abrupt("return", new p({
                  code: "STRIPE_CLIENT_ERROR",
                  field: "paymentMethod",
                  message: "Stripe SCA error"
                }));
              case 21:
                t instanceof FormData ? t.delete("paymentMethod") : delete t.paymentMethod, E(t, "paymentIntent", n.paymentIntent.id), E(t, "resubmitKey", d.resubmitKey);
                _context2.next = 24;
                return m(t);
              case 24:
                x = _context2.sent;
                return _context2.abrupt("return", (k(x), x));
              case 26:
                return _context2.abrupt("return", d);
              case 27:
                _context2.next = 29;
                return m(t);
              case 29:
                T = _context2.sent;
                return _context2.abrupt("return", (k(T), T));
              case 31:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })();
      });
    }
  }]);
  return R;
}();
function k(e) {
  var r = e.kind;
  if (r !== "success" && r !== "error") throw new Error("Unexpected submission result (kind: ".concat(r, ")"));
}
var F = function F(e) {
    return new R(e);
  },
  U = function U() {
    return C || (C = F()), C;
  },
  C;
0 && (module.exports = {
  SubmissionError: SubmissionError,
  appendExtraData: appendExtraData,
  createClient: createClient,
  getDefaultClient: getDefaultClient,
  isSubmissionError: isSubmissionError
});